/**
 * @file Remarks.jsx
 * @author Rishikesh
 * @date 2024-09-25
 * @description Component of lead-deatails to list the remarks.
 */
import {
  Box,
  Divider,
  List,
  ListItem,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";

export const Remarks = ({ isLoading, followuplist }) => {
  return (
    <Box
      width="100%"
      flex={1}
      borderRadius="12px"
      px="8px"
      py={1.5}
      bgcolor="#F7F7F7"
      display="flex"
      overflow="auto"
      flexDirection="column"
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        {isLoading ? (
          <Skeleton variant="rounded" sx={{ mb: 1 }} width={140} height={24} />
        ) : (
          <Typography fontWeight={600} fontSize={18} color="#222222">
            Remarks
          </Typography>
        )}
      </Stack>
      <Divider />
      <List dense sx={{ width: "100%", mt: 0.5, flex: 1, overflowY: "auto" }}>
        {isLoading ? (
          Array.from({ length: 7 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              sx={{ mt: 1 }}
              width={"100%"}
              height={32}
            />
          ))
        ) : followuplist && followuplist.length > 0 ? (
          followuplist.map((item, idx) => (
            <React.Fragment key={item.id}>
              <Stack>
                <ListItem sx={{ p: 0 }}>
                  <Typography variant="body2">{item.followupnotes}</Typography>
                </ListItem>
                <Stack
                  display="flex"
                  direction="row"
                  alignItems="center"
                  justifyContent="end"
                  spacing={2}
                >
                  <Box
                    minWidth={160}
                    justifyContent="center"
                    textAlign="center"
                    py={0.5}
                    bgcolor="#FA8232"
                    borderRadius="4px"
                  >
                    <Typography variant="body2" color="white">
                      {item.followupdate
                        ? dayjs(item.followupdate).format("ddd MMM DD YYYY")
                        : ""}
                    </Typography>
                  </Box>
                  <Box
                    minWidth={80}
                    justifyContent="center"
                    textAlign="center"
                    py={0.5}
                    bgcolor="#FA8232"
                    borderRadius="4px"
                  >
                    <Typography variant="body2" color="white">
                      {item.followuptype}
                    </Typography>
                  </Box>
                </Stack>
              </Stack>
              {idx < followuplist.length - 1 && <Divider sx={{ my: 1 }} />}
            </React.Fragment>
          ))
        ) : (
          <Typography variant="body2" color="#999999" textAlign="center" mt={2}>
            No remarks available.
          </Typography>
        )}
      </List>
    </Box>
  );
};
